module.exports = __webpack_public_path__ + "static/img/三星模块.167b95a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/三星模块.png
// module id = m6nY
// module chunks = 1